import { servObj } from "../init_glob";

function post(sendData) { // sendData
    const ID = "AKfycbzPWeD7WRy91A6q204nHrgwnR-PgQ-1_5CF6NIAZZ8nkTFaQ0YQyZBIQjL8JUeeRhcI"

    fetch(`https://script.google.com/macros/s/${ID}/exec`, {
        method: 'POST',
        headers: {
            "Content-Type": "text/plain; charset=utf-8",
        },
        body: JSON.stringify(sendData)
    })
    .then(response => response.text())
    .then(data => {
        //console.log(data)
        servObj.googleData = data
        const iframe = document.getElementById('iframe');
        const b = iframe.contentWindow.document.getElementById('download_pdf')
        b.click()
    })
    .catch((error) => {
        console.log(error)
    })
}

function make_pdf(isDownlaod = false) {
    post({ttt: "ttt"})
    
    // const iframe = document.getElementById('iframe');
    // const b = iframe.contentWindow.document.getElementById('download_pdf')
    // b.click()
}

export {make_pdf}